import React, { useEffect } from 'react';
import customCodesSx from 'pages/ClinicSettings/CustomCodes/CustomCodes.styles';
import DashboardCard from 'components/DashboardCard';
import DataObject from '@mui/icons-material/DataObject';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from './CustomCodes.redux';
import { DataGrid } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { formatCodeType } from './CustomCodes.utils';

const columns = [
    { field: 'symbol_abbreviation', headerName: 'Abbreviation', flex: 1 },
    { field: 'symbol_name', headerName: 'Name', flex: 1 },
    {
        field: 'symbol_chart_config',
        headerName: 'Type',
        flex: 1,
        valueFormatter: (value) => formatCodeType(value?.type),
    },
    { field: 'created_by_name', headerName: 'Created By', flex: 1 },
    {
        field: 'created_at',
        headerName: 'Create Date',
        flex: 1,
        valueFormatter: (value) => (value ? dayjs(value).format('MMMM D, YYYY') : ''),
    },
    { field: 'updated_by_name', headerName: 'Updated By', flex: 1 },
    {
        field: 'updated_at',
        headerName: 'Update Date',
        flex: 1,
        valueFormatter: (value) => (value ? dayjs(value).format('MMMM D, YYYY') : ''),
    },
];

const CustomCodeList = () => {
    const theme = useTheme(),
        sx = customCodesSx(theme),
        dispatch = useDispatch(),
        codes = useSelector((state) => state.customCodes.codes);

    const rows = codes.map((code, index) => ({
        ...code,
        __rowId: code.id ?? code.symbol_id ?? `${code.symbol_name}-${index}`,
    }));

    const handleAddNew = () => dispatch(actions.setState({ showForm: true }));

    const handleRowClick = (code) => {
        const { __rowId, ...codeData } = code;
        dispatch(
            actions.setState({
                step: 'edit-code',
                showForm: true,
                category: codeData.symbol_category,
                type: codeData.symbol_chart_config.type,
                conf: { ...codeData },
            })
        );
    };

    useEffect(() => {
        dispatch(actions.loadCustomCodes());

        return () => dispatch(actions.setState({ codes: [] }));
    }, [dispatch]);

    return (
        <DashboardCard
            color={'orange'}
            icon={<DataObject />}
            topContent={'Custom Codes'}
            topLabel={
                <>
                    <div>Choose a code to edit or</div>
                    <div>
                        <Button variant="contained" size="small" color="primary" sx={sx.buttons} onClick={handleAddNew}>
                            <Add /> Add New
                        </Button>
                    </div>
                </>
            }
            size={'xl'}
        >
            <div style={{ height: 520, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.__rowId}
                    onRowClick={(params) => handleRowClick(params.row)}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                page: 0,
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[5, 10, 20, 50]}
                    disableColumnSorting
                    disableColumnMenu
                />
            </div>
        </DashboardCard>
    );
};

export default CustomCodeList;
